const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class Stockpile extends Action {
    constructor(){
        super(
            Age.AgeA,
            ActionNames.Stockpile, 
            `Gain 1 food and 1 resource.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }
}

module.exports = Stockpile;
